import { forwardRef } from "react"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { SwitcherMenuItem } from "lib/@components/nav-switcher/switcher-menu-item"
import { CompanyAvatar } from "./company-avatar"

export const CompanyMenuItem = forwardRef(function CompanyMenuItem(
    { item, index, previous: __previous, next: __next, last: __last, remove: __remove, ...props },
    ref
) {
    const { selectCompany, closeSwitcher } = useBoundContext()
    const name = item.name || item.displayName

    return (
        <SwitcherMenuItem
            ref={ref}
            index={index}
            dataCy={`company-menu-item-${index}`}
            icon={<CompanyAvatar client={item} alt={name} />}
            label={name}
            accessibleLabel={`Change company to ${name}`}
            onSelect={select}
            {...props}
        />
    )

    function select() {
        selectCompany(item.id)
        closeSwitcher()
    }
})
